/**
 * Shared HTML fragments for print / export documents.
 * Convention: pass activeOrg?.letterheadImageUrl from useOrg() where applicable.
 */

function escAttr(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;');
}

/**
 * Returns the letterhead HTML block for any print/export document.
 * @param {string|null|undefined} letterheadImageUrl
 * @returns {string}
 */
export function getLetterheadHtml(letterheadImageUrl) {
  if (!letterheadImageUrl || typeof letterheadImageUrl !== 'string') return '';
  const url = letterheadImageUrl.trim();
  if (!url.startsWith('https://') && !url.startsWith('http://')) return '';
  return `
    <div class="document-letterhead">
      <img
        src="${escAttr(url)}"
        alt="Antet spital"
        style="width: 100%; max-height: 150px; object-fit: contain; object-position: left; display: block; margin-bottom: 16px;"
      />
    </div>
  `;
}
